var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.color),function(item,index){return _c('div',{key:index,staticClass:"rounded mr-2",staticStyle:{"width":"20px","height":"20px","border":"1px solid black"},style:({ backgroundColor: item })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }